import { render, staticRenderFns } from "./leftApp.vue?vue&type=template&id=34878696&scoped=true&"
import script from "./leftApp.vue?vue&type=script&lang=js&"
export * from "./leftApp.vue?vue&type=script&lang=js&"
import style0 from "./leftApp.vue?vue&type=style&index=0&id=34878696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34878696",
  null
  
)

export default component.exports